var map = {
	"./en/banner_01.png": "ynhH",
	"./es/banner_01.png": "DzLW",
	"./pt/banner_01.png": "ARNj"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Ky3h";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/banner_01\.png$
// module id = Ky3h
// module chunks = 0